import UserService from '@/services/user';
import {userHaveRoles} from '@/services/utilities';

export default {
	namespaced: true,
	state: {
	},

	getters: {
		async getUsers({ commit, state, getters, dispatch }) {
			try {
				const userLogin = JSON.parse(window.localStorage.getItem('user_data'))
				let response
				if (userHaveRoles(["super_admin"])) {
					response = await UserService.getUsers()
				} else {
					response = await UserService.getUsersCompany()
				}
				return response
			} catch (e) {
				console.log(e)
			}
		},
		async getUsersUnverified({ commit, state, getters, dispatch }) {
			try {
				// const userLogin = JSON.parse(window.localStorage.getItem('user_data'))
				let response
				if (!userHaveRoles(["super_admin"])) {
					response = await UserService.getUsers()
				} else {
				response = await UserService.getUsersUnverified()
				}

				return response
			} catch (e) {
				console.log(e)
			}
		},
		async getRoles({ commit, state, getters, dispatch }) {
			try {
				const response = await UserService.getRoles()
				return response
			} catch (e) {
				console.log(e)
			}
		}
	},

	actions: {
		async logIn({ commit, state, getters, dispatch }, payload) {
			// const { email, password } = payload;

			// const response = await UserService.logIn(email, password);

			// if (!response.data.success) {
			// 	return response;
			// } else {
			// 	window.localStorage.setItem('access_token', response.data.attributes.token);
			// 	return response;
			// }
			return 'successfull'
		},
		async createUser({ commit, state, getters, dispatch }, payload) {
			let response
			try {
				response = await UserService.createUser({
					...payload,
					activated: false,
				});
			} catch (e) {
				console.log(e)
			}
			return response;
		},
		async updateUser({ commit, state, getters, dispatch }, payload) {
			let response
			try {
				response = await UserService.updateUser({
					...payload,
					role_id: payload.roles[0].id
				});
			} catch (e) {
				console.log(e);
			}
			return response
		},
		async deleteUser({ commit, state, getters, dispatch }, id) {
			try {
				await UserService.deleteUser(id);
			} catch (e) {
				console.log(e);
			}
		},
		async activatedUser({ commit, state, getters, dispatch }, id) {
			try {
				await UserService.activatedUser(id);
			} catch (e) {
				console.log(e);
			}
		},
		async getUserById({ commit, state, getters, dispatch }, id) {
			try {
				let response = await UserService.getUserById(id)
				return response
			} catch (e) {
				console.log(e)
			}
    },
    async getUserByName({commit, state, getters, dispatch},payload){
      try{
        let response = await UserService.getUserByName({q: payload.name})
				return response
      }catch(e){
        console.log(e)
      }
		},
		async getUsersByEmailOrPhone({ commit, state, getters, dispatch }, query) {
			try {
				let response = await UserService.getUsersByEmailOrPhone(query)
				return response
			} catch (e) {
				console.log(e)
			}
    },
    async forgotPassword({ commit, state, getters, dispatch}, payload) {
      try{
        let response = await UserService.forgotPassword(payload);
        return response;
      }catch (e) {
        console.log(e);
      }
    }
	},

	mutations: {
		// SET_VALUE_FROM_API(state, payload) {
		// 	state.valueFromApi = payload;
		// }
	}
};
